import React from "react";
import { useStoreState } from "../hooks/ep";
import {
  useEnsureFlopptionsData,
  useEnsureOpportunitiesData,
  useEnsureTripNotesData,
} from "../helpers/useEnsureData";
import AgTable from "./AgTable";
import "styled-components/macro";
import { useColDefs } from "./opps-table-coldefs";
import { ReportActionModalWrapper } from "./reporting-actions/modal-or-drawer";
import { Spinner } from "@blueprintjs/core";
import { hashFlopption } from "../store/model-action-reports";

function useOpportunitiesRowData() {
  return useStoreState((s) => s.opportunities.initialData);
}

function TableInner() {
  const rowData = useOpportunitiesRowData();
  rowData.forEach((row) => {
    row.id = hashFlopption(row);
  });

  const colDefs = useColDefs("opportunities", rowData);

  return (
    <>
      <AgTable
        rowData={rowData}
        columnDefs={colDefs}
        tableName="opportunities"
      />
      <ReportActionModalWrapper />
    </>
  );
}

export function OpportunitiesTable() {
  const oppsLoading = useEnsureOpportunitiesData();
  const floppsLoading = useEnsureFlopptionsData();
  const notesLoading = useEnsureTripNotesData();
  return oppsLoading || floppsLoading || notesLoading ? (
    <Spinner />
  ) : (
    <TableInner />
  );
}
